import React from 'react'
import ProfileSection from '../../sections/Profile/ProfileSection/ProfileSection'

const MyProfilePage = () => {
    return (
        <div className='flex justify-center w-full'>
            <ProfileSection />
        </div>
    )
}

export default MyProfilePage
